/* global Version, DataDogService */

import { datadogRum } from '@datadog/browser-rum';
import { isStaticRender } from './ContentHelper';

export default function initializeDataDog() {
  const { dataDog: dataDogConfig } = window.ExternalConfig;
  if (!isStaticRender() && DataDogService && dataDogConfig) {
    const { applicationId, clientToken, env, site } = dataDogConfig;
    datadogRum.init({
      applicationId,
      clientToken,
      defaultPrivacyLevel: 'mask-user-input',
      env,
      sampleRate: 100,
      service: DataDogService,
      site,
      trackInteractions: true,
      version: Version,
    });
    datadogRum.setGlobalContext({
      application: 'web',
      business_unit: 'foxnation',
      owner: 'fox-nation-web',
    });
    datadogRum.startSessionReplayRecording();
  }
}
